import { type SxProps } from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import type { FC } from "react";

interface MdaiDividerProps {
  sx?: SxProps;
  containerStyles?: SxProps;
}

export const MdaiDivider: FC<MdaiDividerProps> = ({ sx, containerStyles }) => {
  return (
    <Container
      sx={[
        { width: "100%", display: "flex", justifyContent: "center" },
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        ...(Array.isArray(containerStyles)
          ? containerStyles
          : [containerStyles]),
      ]}
    >
      <Box
        sx={[
          {
            my: 3,
            width: "100%",
            height: "2px",
            maxWidth: "1000px",
            background:
              "linear-gradient(90deg, rgba(153, 153, 153, 0.00) 0%, rgba(171, 71, 188, 0.50) 45.67%, rgba(153, 153, 153, 0.00) 100%)",
          },
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      />
    </Container>
  );
};
